import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'app/app.service';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';
import { AlertInboxComponent } from '../alert-inbox/alert-inbox.component';

@Component({
	selector: 'modal-alert-inbox',
	templateUrl: './modal-alert-inbox.component.html'
})
export class ModalAlertInboxComponent extends UIModalBaseComponent {

	inbox: AlertInboxComponent;

	@ViewChild(AlertInboxComponent) set inboxRef(value: AlertInboxComponent) {
		this.inbox = value;
		this.cd.detectChanges();
	}

	constructor(
		public app: AppService,
		private router: Router,
		private cd: ChangeDetectorRef
	) {
		super();
	}

	open() {
		this.modal.open();
	}

	viewAll() {
		const nav = this.app.routeData?.navigation;
		const keepNav = ['settings', 'purchase', 'warehouse'].includes(nav);
		this.modal.close();
		this.router.navigate(['/', this.app.org, 'alert'], keepNav ? { queryParams: { nav } } : {});
	}

}
